module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/flow_arrow_mail_sp-2217e5cceb1afffb77fc4fb4cfe67503.svg";